import { errorToast } from "@/v2-ui/toast"
import {
  type ConfirmButtonProps,
  ConfirmButton,
} from "@/v2-backoffice-client/components/button"
import { useTenantUserRestoreManyMutation } from "@/v2-backoffice-client/tenant/user/restore/many/tenant.user.restore.many.mutation"

export type TenantUserRestoreManyButtonProps = Omit<
  ConfirmButtonProps,
  "onConfirm"
> & {
  userTenantIds: number[]
  onCompleted?(): void
}

function TenantUserRestoreManyButton(props: TenantUserRestoreManyButtonProps) {
  const { userTenantIds, confirmContent, onCompleted, ...confirmButtonProps } =
    props

  const count = userTenantIds.length
  const [restore, { loading, error }] = useTenantUserRestoreManyMutation({
    onCompleted,
  })

  errorToast(error, {
    title: `Failed to restore ${count} user(s) to the team`,
  })

  return (
    <ConfirmButton
      id="tenant-user-restore-many-button"
      variant="success"
      confirmVariant="success"
      size="tiny"
      iconSrc="undo-alt"
      content="Restore users to team"
      confirmContent={
        confirmContent ??
        `Are you sure you want to restore ${count} user(s) to the team?`
      }
      isLoading={loading}
      onConfirm={() => {
        restore({ variables: { ids: userTenantIds } })
      }}
      {...confirmButtonProps}
    />
  )
}

export default TenantUserRestoreManyButton
